export default __webpack_public_path__ + "static/undraw_online_connection_6778-425106f90eb24ce307836fdb5e63411c.svg";